import { EntitlementMode } from '../models/enums/entitlement-mode.enum';
import { GROUP_ENTITY_ID, USER_ENTITY_ID } from './entity-consts';

export const ENTITLEMENT_TYPE = {
  System: EntitlementMode.System,
  DataModule: EntitlementMode.DataModule,
  DataEntity: EntitlementMode.DataEntity,
  DataViews: EntitlementMode.DataViews,
};

export const ENTITLED_ENTITY_TYPE = {
  Group: GROUP_ENTITY_ID.toLowerCase(),
  User: USER_ENTITY_ID.toLowerCase(),
};
